import ArchiveFiltersController from '../ArchiveFiltersController';
import type { ArchiveFilterModule } from '../types';

class ProgramCatFilter implements ArchiveFilterModule {
    private controller: ArchiveFiltersController | null = null;
    private control: HTMLInputElement | HTMLSelectElement | null = null;

    public mount(controller: ArchiveFiltersController): void {
        this.controller = controller;
        this.init();
    }

    private init(): void {
        this.control = document.querySelector<HTMLInputElement | HTMLSelectElement>('select[name="program_cat"]')
            ?? document.querySelector<HTMLInputElement | HTMLSelectElement>('[data-program-cat-select]');

        if (!this.control) {
            return;
        }

        this.control.addEventListener('change', () => {
            if (!this.control) {
                return;
            }

            this.controller?.setProgramCat(this.control.value);
        });
    }
}

export default ProgramCatFilter;